import { render, staticRenderFns } from "./SpImage.vue?vue&type=template&id=5aac8b62&scoped=true"
import script from "./SpImage.vue?vue&type=script&lang=js"
export * from "./SpImage.vue?vue&type=script&lang=js"
import style0 from "./SpImage.vue?vue&type=style&index=0&id=5aac8b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac8b62",
  null
  
)

export default component.exports